module.exports = __webpack_public_path__ + "static/img/Logo.a157f985.png";